// extracted by mini-css-extract-plugin
export default {"scoreRulesContainer":"ScoreRules_scoreRulesContainer__BLGLJ","scoreRulesText":"ScoreRules_scoreRulesText__T3OGJ","nextRow":"ScoreRules_nextRow__+xhF3"};